export const wordsToTestId = (s: string) => s.toLowerCase().replace(/ /g, '-')



// WEBPACK FOOTER //
// ./src/utils/index.ts